import { render, staticRenderFns } from "./DeletePassword.vue?vue&type=template&id=1c14d521&scoped=true&lang=pug&"
import script from "./DeletePassword.vue?vue&type=script&lang=js&"
export * from "./DeletePassword.vue?vue&type=script&lang=js&"
import style0 from "./DeletePassword.vue?vue&type=style&index=0&id=1c14d521&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c14d521",
  null
  
)

export default component.exports